import styled from "styled-components";
import { useAppSelector } from "../../../../../../redux";
import { usePostCardContext } from "../PostCardContent";

export const GIFContent = () => {
  const { postId, isOnExpandedPostView } = usePostCardContext();
  const { processed_posts } = useAppSelector((state) => state.newsfeed);

  const post = processed_posts[postId];
  if (!post) return null;
  const gifs = post.media.gifs;
  if (!gifs || gifs.length === 0) return null;

  return (
    <>
      {gifs.map((gif) => (
        <PaddingContainer
          key={gif.id}
          $isOnExpandedPostView={isOnExpandedPostView}
        >
          <GifImage src={gif.url} alt="post-GIF" />
        </PaddingContainer>
      ))}
    </>
  );
};
const GifImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  display: block;
`;

const PaddingContainer = styled.div<{ $isOnExpandedPostView: boolean }>(
  ({ $isOnExpandedPostView, theme }) => `
  padding: ${$isOnExpandedPostView && theme.spacing["spacing-2"].value}rem
    ${$isOnExpandedPostView && theme.spacing["spacing-4"].value}rem;
`
);
